import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
} from 'antd';

import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { onError } from 'utils/handlers';
import ModalDelete from 'components/ModalDelete';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';
import {
  deleteArchivoDeDireccionVerificada,
  getArchivosDeDireccionesVerificadas,
  patchArchivoDeDireccionVerificada,
  postArchivoDeDireccionVerificada,
} from 'api/catalogos/archivosDeDireccionVerificada';
import { getVerificados } from 'api/empresas/direccionVerificada';
import Uploader from 'components/Uploader';

// eslint-disable-next-line react/prop-types
const ArchivoDeDireccionVerificada = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [direccionVerificada, setDireccionVerificada] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _archivoDeDireccionVerificada = await getArchivosDeDireccionesVerificadas();
    setData(_archivoDeDireccionVerificada);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const _archivoDeDireccionVerificada = await getArchivosDeDireccionesVerificadas();
      const _direccionVerificada = await getVerificados();
      if (mounted) {
        setData(_archivoDeDireccionVerificada);
        setDireccionVerificada(_direccionVerificada);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setSelectedRowKeys([]);
    form.resetFields();
    setVisibleAlert(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const saved = await (key ? patchArchivoDeDireccionVerificada(key, values)
        : postArchivoDeDireccionVerificada(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteArchivoDeDireccionVerificada(key);
    if (deleted) {
      onCancel();
      setVisibleAlert(false);
      await fetchData();
    }
    setLoading(false);
  };
  const onClickAdd = () => {
    setVisible(true);
    setSelectedRowKeys([]);
    form.resetFields();
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue({
      ...record,
      anio: record?.anio.format('YYYY'),
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 100,
    },
    {
      titleText: 'Año',
      dataIndex: 'anio',
      key: 'anio',
      width: 300,
      render: (val) => (val?.format(DATE_FRONTEND_FORMAT)),

    },
  ];

  const rules = {
    required: [
      {
        required: true,
        message: 'El campo es requerido',
      },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            mobileColIndex={0}
            rowKey="id"
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            allowImport
            permission={permission}
          />
        ) : (
          <Card
            bordered={false}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
              />
             )}
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Archivo De Direccion Verificada`}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="descripcion"
                    label="Descripción"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="extension_del_documento"
                    label="Extensión Del Documento"
                    hasFeedback
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    label="Tamaño"
                    name="tamano"
                    decimal
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="direccion_verificada_id"
                    label="Direccion Verificada"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select dataSource={direccionVerificada} mode="multiple" />
                  </Form.Item>
                </Col>
                <Uploader
                  title="Archivo"
                  limitMB={50}
                  formItemName="archivo"
                  allowedExtensions={['pdf', 'docx', 'doc']}
                  rules={rules.documento}
                  allowPreview
                />
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => {
            setVisibleAlert(false);
            setSelectedRowKeys([]);
          }}
          visible={visibleAlert}
          content="El Archivo De Direccion seleccionado"
        />
      </Spin>
    </Row>
  );
};
export default ArchivoDeDireccionVerificada;
